import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";
const RESOURCE_NAME = "/api/department_notifications";

export default {
  async getAllNotifications(params) {
    return await Api()
      .get(RESOURCE_NAME, { params })
      .catch((err) => errorHandler(err, null));
  },
  async getDepartmentNotifications(id) {
    return await Api()
      .get(RESOURCE_NAME + "/" + id)
      .catch((err) => errorHandler(err, null));
  },
  //No API
  //   async postNotification(params) {
  //     return await Api()
  //       .post(RESOURCE_NAME, params)
  //       .catch((err) => errorHandler(err, null));
  //   },
  // async deleteProvider(id) {
  //   return await Api()
  //     .delete(RESOURCE_NAME + "/" + id)
  //     .catch((err) => errorHandler(err, null));
  // },
  async updateDepartmentNotification(id, params) {
    return await Api()
      .put(RESOURCE_NAME + "/" + id, params)
      .catch((err) => errorHandler(err, null));
  },
  async archiveDepartmentNotification(id) {
    return await Api()
      .post(RESOURCE_NAME + "/" + id + "/archive")
      .catch((err) => errorHandler(err, null));
  },
  async unarchiveDepartmentNotification(id) {
    return await Api()
      .post(RESOURCE_NAME + "/" + id + "/unarchive")
      .catch((err) => errorHandler(err, null));
  },
  async pinDepartmentNotification(id) {
    return await Api()
      .post(RESOURCE_NAME + "/" + id + "/pin")
      .catch((err) => errorHandler(err, null));
  },
  async unpinDepartmentNotification(id) {
    return await Api()
      .post(RESOURCE_NAME + "/" + id + "/unpin")
      .catch((err) => errorHandler(err, null));
  },
  async patchDepartmentNotification(id, params) {
    return await Api()
      .put(RESOURCE_NAME + "/" + id, params)
      .catch((err) => errorHandler(err, null));
  },
};
